const entityKeys = (entity) => [entity?.documentId, entity?.id]
    .filter((value) => value !== null && value !== undefined)
    .map(String);

const sameEntity = (left, right) => (
    entityKeys(left).some((key) => entityKeys(right).includes(key))
);

const inviteeKey = (invitation) => String(
    invitation?.invitee?.documentId || invitation?.invitee?.id || "",
);

export function buildWorkspaceMemberRows({memberships = [], invitations = [], ownerMembership} = {}) {
    const latestInvitationByInvitee = new Map();
    for (const invitation of invitations) {
        const key = inviteeKey(invitation);
        if (key && !latestInvitationByInvitee.has(key)) latestInvitationByInvitee.set(key, invitation);
    }

    const memberRows = memberships
        .filter((membership) => membership?.memberShipStatus !== "removed")
        .map((membership) => {
            const member = membership?.member || {};
            const invitation = latestInvitationByInvitee.get(String(member.documentId || member.id || ""));
            const isWorkspaceOwner = sameEntity(membership, ownerMembership)
                || sameEntity(member, ownerMembership?.member || ownerMembership)
                || (membership?.user_roles || []).some((role) => role?.scope_type === "workspace" && role?.role === "owner");
            return {
                rowType: "member",
                id: `member-${membership?.documentId || membership?.id}`,
                membershipId: membership?.documentId || membership?.id,
                member,
                memberShipStatus: membership?.memberShipStatus,
                userRoles: membership?.user_roles || [],
                updatedAt: membership?.updatedAt,
                isWorkspaceOwner,
                inviter: invitation?.inviter?.member,
                invitedAt: invitation?.createdAt,
            };
        });

    const memberKeys = new Set(memberRows.flatMap((row) => entityKeys(row.member)));
    const pendingRows = invitations
        .filter((invitation) => invitation?.invitationStatus === "pending")
        .filter((invitation) => !entityKeys(invitation?.invitee).some((key) => memberKeys.has(key)))
        .map((invitation) => ({
            rowType: "invitation",
            id: `invitation-${invitation?.documentId || invitation?.id}`,
            invitationId: invitation?.documentId || invitation?.id,
            member: invitation?.invitee || {},
            inviter: invitation?.inviter?.member,
            invitedAt: invitation?.createdAt,
            invitationRole: invitation?.role,
            memberShipStatus: "pending",
            userRoles: [],
            isWorkspaceOwner: false,
        }));

    return [...memberRows, ...pendingRows];
}

export function memberCapacity(limitValue, rows = []) {
    const limitMap = {"up-to-10": 10, "up-to-20": 20, "up-to-50": 50};
    const used = rows.length;
    const unlimited = limitValue === "unlimited" || limitValue?.unlimited === true;
    const numericLimit = Number(limitValue?.limit ?? limitValue?.value ?? limitValue);
    const limit = unlimited
        ? null
        : (Number.isFinite(numericLimit) && numericLimit >= 0 ? numericLimit : (limitMap[limitValue] || 10));
    return {
        used,
        limit,
        unlimited,
        percent: unlimited ? 0 : Math.min(100, Math.round((used / limit) * 100)),
    };
}
